module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/244-south-sudan-12950aa19b10fb9697185a550b07ea44.svg";